import { Controller } from "@hotwired/stimulus"

// Show/hide the typed password. Toggles the field between password and text and
// swaps the eye / eye-off icon. Purely client-side.
export default class extends Controller {
  static targets = ["field", "shown", "hidden"]

  toggle() {
    const revealing = this.fieldTarget.type === "password"
    this.fieldTarget.type = revealing ? "text" : "password"
    this.shownTarget.classList.toggle("hidden", !revealing)
    this.hiddenTarget.classList.toggle("hidden", revealing)
    this.fieldTarget.focus()
  }
}
